import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getCliente } from '../services/api';
import { Container, Card, Button, Row, Col, Spinner, Alert, Tabs, Tab } from 'react-bootstrap';
import ClienteOrdiniTab from '../components/tabs/ClienteOrdiniTab';
import ClienteProdottiTab from '../components/tabs/ClienteProdottiTab';

function ClientiDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backTo = location.state?.from || '/clienti';
  const tornaIndietro = useTornaIndietro('/clienti');
  const [cliente, setCliente] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [key, setKey] = useState('dettagli');

  useEffect(() => {
    const fetchCliente = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getCliente(id);
        setCliente(response.data);
      } catch (err) {
        setError('Errore nel caricamento del cliente.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchCliente();
  }, [id]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Caricamento cliente...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <Button variant="primary" onClick={() => tornaIndietro()}>Torna alla lista clienti</Button>
      </Container>
    );
  }

  if (!cliente) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">Cliente non trovato.</Alert>
        <Button variant="primary" onClick={() => tornaIndietro()}>Torna alla lista clienti</Button>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      <Row className="mb-3 align-items-center">
        <Col>
          <h2 className="mb-0">Dettaglio Cliente: {cliente.nome} {cliente.cognome}</h2>
        </Col>
        <Col xs="auto" className="ms-auto">
          <Button variant="secondary" onClick={() => tornaIndietro()} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" onClick={() => navigate(`/clienti/edit/${id}`)} className="me-2">
            Modifica
          </Button>
          <Button variant="info" as={Link} to={`/clienti/print/${id}`}>
            Stampa
          </Button>
        </Col>
      </Row>

      <Tabs
        id="cliente-detail-tabs"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="dettagli" title="Dettagli Cliente">
            <Card className="mb-4">
                <Card.Header as="h5">Dati Anagrafici</Card.Header>
                <Card.Body>
                <Row>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>ID:</strong></Col>
                        <Col xs={8}>{cliente.id}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Nome:</strong></Col>
                        <Col xs={8}>{cliente.nome}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Cognome:</strong></Col>
                        <Col xs={8}>{cliente.cognome}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Luogo di Nascita:</strong></Col>
                        <Col xs={8}>{cliente.luogo_nascita || 'N/A'}</Col>
                    </Row>
                    </Col>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Data di Nascita:</strong></Col>
                        <Col xs={8}>{cliente.data_nascita || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Codice Fiscale:</strong></Col>
                        <Col xs={8}>{cliente.codice_fiscale || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Partita IVA:</strong></Col>
                        <Col xs={8}>{cliente.partita_iva || 'N/A'}</Col>
                    </Row>
                    </Col>
                </Row>
                </Card.Body>
            </Card>
            <Card className="mb-4">
                <Card.Header as="h5">Indirizzo</Card.Header>
                <Card.Body>
                <Row>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Indirizzo:</strong></Col>
                        <Col xs={8}>{cliente.indirizzo || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>N. Civico:</strong></Col>
                        <Col xs={8}>{cliente.numero_civico || 'N/A'}</Col>
                    </Row>
                    {cliente.presso && (
                    <Row className="mb-2">
                        <Col xs={4}><strong>Presso:</strong></Col>
                        <Col xs={8}>{cliente.presso}</Col>
                    </Row>
                    )}
                    <Row className="mb-2">
                        <Col xs={4}><strong>CAP:</strong></Col>
                        <Col xs={8}>{cliente.cap || 'N/A'}</Col>
                    </Row>
                    </Col>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Città:</strong></Col>
                        <Col xs={8}>{cliente.citta || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Provincia:</strong></Col>
                        <Col xs={8}>{cliente.provincia || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Nazione:</strong></Col>
                        <Col xs={8}>{cliente.nazione || 'N/A'}</Col>
                    </Row>
                    </Col>
                </Row>
                </Card.Body>
            </Card>
            <Card className="mb-4">
                <Card.Header as="h5">Contatti</Card.Header>
                <Card.Body>
                <Row>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Email:</strong></Col>
                        <Col xs={8}>{cliente.email || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>PEC:</strong></Col>
                        <Col xs={8}>{cliente.pec || 'N/A'}</Col>
                    </Row>
                    </Col>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Telefono:</strong></Col>
                        <Col xs={8}>{cliente.telefono || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Cellulare:</strong></Col>
                        <Col xs={8}>{cliente.cellulare || 'N/A'}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Codice Destinatario:</strong></Col>
                        <Col xs={8}>{cliente.codice_destinatario || 'N/A'}</Col>
                    </Row>
                    </Col>
                </Row>
                </Card.Body>
            </Card>
            <Card className="mb-4">
                <Card.Header as="h5">Altri Dati</Card.Header>
                <Card.Body>
                <Row>
                    <Col md={6}>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Punti Fedeltà:</strong></Col>
                        <Col xs={8}>{cliente.punti_fedelta}</Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={4}><strong>Origine:</strong></Col>
                        <Col xs={8}>{cliente.origine || 'N/A'}</Col>
                    </Row>
                    </Col>
                </Row>
                </Card.Body>
            </Card>
        </Tab>
        <Tab eventKey="ordini" title="Storico Ordini">
            <ClienteOrdiniTab clienteId={id} />
        </Tab>
        <Tab eventKey="prodotti" title="Riepilogo Prodotti">
            <ClienteProdottiTab clienteId={id} />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default ClientiDetail;
